(() => {
  "use strict";
  const enhance = () => {
    document.querySelectorAll(".template-article .article-template__content table").forEach((table) => {
      if (table.dataset.vassiaMobileReady === "1") return;
      table.dataset.vassiaMobileReady = "1";
      const rows = Array.from(table.rows);
      const heading = table.tHead && table.tHead.rows.length ? table.tHead.rows[0] : rows.find((row) => row.cells.length > 1 && Array.from(row.cells).every((cell) => cell.tagName === "TH"));
      const labels = heading ? Array.from(heading.cells).map((cell) => (cell.textContent || "").replace(/\s+/g, " ").trim().slice(0, 95)) : [];
      const bodyRows = rows.filter((row) => row !== heading);
      const simple = labels.length > 1 && labels.length <= 6 && labels.every(Boolean) && bodyRows.length > 0 && rows.every((row) => Array.from(row.cells).every((cell) => cell.colSpan === 1 && cell.rowSpan === 1)) && bodyRows.every((row) => row.cells.length === labels.length);
      if (simple) {
        table.classList.add("vassia-table--cards");
        if (heading && !table.tHead) heading.classList.add("vassia-table__head");
        bodyRows.forEach((row) => Array.from(row.cells).forEach((cell, index) => {
          cell.dataset.vassiaLabel = labels[index];
        }));
        return;
      }
      const wrapper = document.createElement("div");
      wrapper.className = "vassia-table-scroll";
      wrapper.tabIndex = 0;
      wrapper.setAttribute("role", "region");
      wrapper.setAttribute("aria-label", "Scrollable comparison table");
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
      const hint = document.createElement("p");
      hint.className = "vassia-table-swipe-hint";
      hint.textContent = "Swipe sideways to view every column";
      wrapper.insertAdjacentElement("afterend", hint);
    });
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", enhance, { once: true });
  } else {
    enhance();
  }
  document.addEventListener("shopify:section:load", enhance);
})();
